export default {
      id: "cosmetic-usage",
      viewBox: "0 0 64 64",
      url: __webpack_public_path__ + "assets/icons/icon-sprite.svg#cosmetic-usage",
      toString: function () {
        return this.url;
      }
    }